module.exports = __webpack_public_path__ + "img/arrow-left.44bb5446.svg";